<template>
  <div id="p0438Page">
    <!-- 搜索 -->
    <el-row style="">
      <el-col :span="24">
        <el-col
          :span="8"
          style="
            display: block;
            text-align: right;
            line-height: 40px;
            padding: 0 20px;
          "
        >
          <!-- 个人用户 -->
          <span class="systemFont1">{{ $t("p0433.personalUser") }}</span>
        </el-col>
        <el-col :span="8">
          <el-col :span="24"
            ><el-input
              v-model="param"
              :placeholder="$t('p0323.text1')"
              maxlength="60"
              clearable
            ></el-input
          ></el-col>
        </el-col>
        <el-col
          :span="8"
          style="display: block; text-align: left; padding: 0 20px"
        >
          <img
            src="../../../../assets/p0322Query.svg"
            width="36px"
            height="36px"
            style="cursor: pointer"
            @click="init(true)"
          />
        </el-col>
      </el-col>
    </el-row>
    <!-- 表格 -->
    <el-row style="margin-top: 20px">
      <el-col :span="22" :offset="1">
        <el-table
          ref="userTableDataRef"
          :data="userTableData"
          v-loading="tableLoading"
          tooltip-effect="dark"
          style="width: 100%"
          :row-key="getRowKeys"
          @select="selectItem"
          @select-all="selectAll"
        >
          <el-table-column
            type="selection"
            :reserve-selection="true"
            :selectable="selected"
            min-width="10"
            align="center"
          >
          </el-table-column>
          <!-- 姓名 -->
          <el-table-column :label="$t('p0433.userName')" min-width="8">
            <template slot-scope="scope">{{
              scope.row.lastName + " " + scope.row.firstName
            }}</template>
          </el-table-column>
          <!-- 英文姓名 -->
          <el-table-column
            prop="name"
            :label="$t('p0433.englishName')"
            min-width="10"
          >
            <template slot-scope="scope">{{
              scope.row.lastNameEn == null && scope.row.firstNameEn == null
                ? ""
                : scope.row.lastNameEn + " " + scope.row.firstNameEn
            }}</template>
          </el-table-column>
          <!-- 昵称 -->
          <el-table-column
            prop="nickname"
            :label="$t('p0433.nickname')"
            min-width="8"
          >
          </el-table-column>
          <!-- 注册邮箱 -->
          <el-table-column
            prop="email"
            :label="$t('p0433.registeredEmail')"
            min-width="12"
          >
          </el-table-column>
          <!-- 注册手机 -->
          <el-table-column
            prop="phone"
            :label="$t('p0433.registeredMobile')"
            width="150px"
            align="center"
          >
          </el-table-column>
          <!-- 注册日期 -->
          <el-table-column
            prop="createTime"
            :label="$t('p0433.registerDate')"
            width="120px"
          >
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-row style="text-align: right; margin-top: 20px">
          <el-col :span="24">
            <div class="block">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="currentPage"
                :page-sizes="[10, 20, 50]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next"
                :total="total"
              >
              </el-pagination>
            </div>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <!-- 提交 -->
    <el-row style="text-align: center; margin: 20px">
      <el-col :span="24">
        <el-button type="submit" @click="addMarketingUserApi">{{
          $t("common.submit")
        }}</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  props: {
    pageNo: {
      type: Number,
      required: true
    },
    marketingUserWatch: {
      type: Boolean,
      required: true
    },
    salesperson: {
      type: Number,
      default: null
    }
  },
  watch: {
    async marketingUserWatch(newValue, oldValue) {
      this.param = "";
      // 执行初始化操作
      await this.init(true);
    }
  },
  data() {
    return {
      tableLoading: false,
      //查询输入框
      param: "",
      // 表格数据
      userTableData: [],
      currentPage: 1,
      pageSize: 10,
      marketingUserVos: [],
      total: 0
    };
  },
  methods: {
    // 用户一览
    async init(val) {
      //判断搜索
      if (val) {
        this.$refs.userTableDataRef.clearSelection();
        this.marketingUserVos = [];
        this.currentPage = 1;
        this.total = 0;
      }
      this.tableLoading = true;
      let url = "/api/MarketingUserAdd/getMarketingUserList";
      this.param;
      await this.$http
        .post(url, {
          param: this.param,
          pageNo: this.pageNo,
          salesperson: this.salesperson,
          currentPage: (this.currentPage - 1) * this.pageSize,
          pageSize: this.pageSize,
          total: this.total
        })
        .then(response => {
          this.tableLoading = false;
          this.response = JSON.stringify(response.data);
          if (response.data.code === 200) {
            //判断是否初始化
            if (response.data.data == null) {
              this.userTableData = [];
            } else {
              this.total = response.data.data[0].total;
              // 渲染页面
              this.userTableData = response.data.data;
            }
          } else {
            this.$message.error(response.data.message);
          }
        })
        .catch(err => {
          this.tableLoading = false;
          this.$message.error(err);
        });
    },
    //选中单列
    selectItem(list, row) {
      this.marketingUserVos = list;
    },
    //全选
    selectAll(selection) {
      // 若取消全选，当前页的选中数据移除
      if (selection.length != null && selection.length === 0) {
        const ids = this.userTableData.map(i => {
          return i.userId;
        });
        for (var i = 0; i < this.marketingUserVos.length; i++) {
          if (ids.indexOf(this.marketingUserVos[i].id) > -1) {
            this.marketingUserVos.splice(i, 1);
            i--;
          }
        }
      }
      const arr = [...selection, ...this.marketingUserVos];
      this.marketingUserVos = Array.from(new Set(arr));
    },
    //添加人员
    addMarketingUserApi() {
      if (this.marketingUserVos == null || this.marketingUserVos.length == 0) {
        this.$message.error(this.$t("p0433.selectUserToAdd"));
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: this.$t("common.loading"),
        background: "rgba(255,255,255,0.8)",
        target: document.querySelector("#p0438Page")
      });
      let url = "/api/MarketingUserAdd/updateMarketingUserList";
      this.$http
        .post(url, {
          updateUser: localStorage.getItem("userId"),
          pageNo: this.pageNo,
          salesperson: this.salesperson,
          marketingUserVos: this.marketingUserVos
        })
        .then(response => {
          loading.close();
          this.response = JSON.stringify(response.data);
          if (response.data.code === 200) {
            //添加成功
            this.$message.success(this.$t("p0433.addedSuccessfully"));
            this.$refs.userTableDataRef.clearSelection();
            this.userTableData = [];
            this.init(true);
          } else {
            loading.close();
            this.$message.error(response.data.message);
          }
        })
        .catch(err => {
          loading.close();
          this.$message.error(err);
        });
    },
    selected(row, index) {
      if (row.invitationStatus == 1) {
        //可选择
        return false;
      } else {
        //不可选择
        return true;
      }
    },
    getRowKeys(row) {
      return row.userId;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      //判断更改页码是否需要查询
      if (this.userTableData == undefined || this.userTableData.length <= 0) {
        return;
      }
      this.init();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.init();
    }
  },
  mounted() {
    this.init(false);
  }
};
</script>

<style lang="scss" scoped>
// 表格样式
>>> .el-table thead {
  font-family: "Arial Negreta", "Arial Normal", "Arial";
  color: #333333;
  font-size: 16px;
}

>>> .el-table__header {
  border-bottom: 3px solid rgb(170, 170, 170);
}

>>> .el-table__row {
  height: 42px;
}

>>> .el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
  border-bottom: 0.5px solid rgb(170, 170, 170);
  padding: 8.5px 0;
}

>>> .el-table--border::after,
.el-table--group::after,
.el-table::before {
  background: none;
}
</style>



// WEBPACK FOOTER //
// src/views/Marketing/MarketingMgt/commonPg/P0438.vue